export const getPrecision = (value?: number | null): number => {
  if (!value) {
    return 0
  }

  const valueString = value.toString()
  const dotPosition = valueString.indexOf('.')
  let precision = 0

  if (dotPosition !== -1) {
    precision = valueString.length - dotPosition - 1
  }

  return precision
}
